import React from 'react';
import Type from 'prop-types';
// import { noop } from 'lodash';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import { ru } from 'locale';

const ConfirmationDialog = props => {
  const {
    open,
    title,
    description,
    cancelButtonText,
    submitButtonText,
    onClose,
    onSubmit,
    ...other
  } = props;

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      onClose={onClose}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {onClose && (
          <Button autoFocus onClick={onClose} color="primary">
            {cancelButtonText}
          </Button>
        )}
        <Button onClick={onSubmit} color="primary">
          {submitButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  open: Type.bool.isRequired,
  title: Type.string.isRequired,
  description: Type.string.isRequired,
  cancelButtonText: Type.string,
  submitButtonText: Type.string,
  onClose: Type.func,
  onSubmit: Type.func.isRequired,
};

ConfirmationDialog.defaultProps = {
  onClose: null,
  cancelButtonText: ru.cancel,
  submitButtonText: ru.save,
};

export default ConfirmationDialog;
